import Main from '@/components/main'
import parentView from '@/components/parent-view'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面不会缓存
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [{
        path: '/login',
        name: 'login',
        meta: {
            title: 'Login - 登录',
            hideInMenu: true
        },
        component: () =>
            import ('@/view/login/login.vue')
    },

    {
        path: '/',
        name: '_home',
        // redirect: '/index/homeIndex',
        component: Main,
        meta: {
            hideInMenu: true,
            notCache: true
        },
        children: [{
            path: '/home',
            name: 'home',
            meta: {
                hideInMenu: true,
                title: '首页',
                notCache: true,
                icon: 'md-home'
            },
            component: () =>
                import ('@/view/single-page/home')
        }]
    },
    {
        path: '/userManagement',
        name: 'userManagement',
        meta: {
            icon: 'ios-appstore',
            showAlways: true
        },
        component: Main,
        children: [{
            path: 'studentManagement',
            name: 'studentManagement',
            meta: {
                title: '学生管理'
            },
            component: () =>
                import ('@/view/userManagement/studentManagement.vue')
        }, {
            path: 'teacherManagement',
            name: 'teacherManagement',
            meta: {
                title: '老师管理'
            },
            component: () =>
                import ('@/view/userManagement/teacherManagement.vue')
        }, ]
    },
    {
        path: '/senateManagement',
        name: 'senateManagement',
        meta: {
            icon: 'ios-appstore',
            showAlways: true
        },
        component: Main,
        children: [{
            path: 'classManagement',
            name: 'classManagement',
            meta: {
                title: '班级管理'
            },
            component: () =>
                import ('@/view/senateManagement/classManagement.vue')
        }, {
            path: 'courseClear',
            name: 'courseClear',
            meta: {
                title: '课程解锁管理'
            },
            component: () =>
                import ('@/view/senateManagement/courseClear.vue')
        }, ]
    },
    {
        path: '/videoManagement',
        name: 'videoManagement',
        meta: {
            icon: 'ios-videocam',
            showAlways: true
        },
        component: Main,
        children: [{
                path: 'teacherVideo',
                name: 'teacherVideo',
                meta: {
                    title: '老师视频管理'
                },
                component: () =>
                    import ('@/view/videoManagement/teacherVideo.vue')
            },

        ]
    },
    {
        path: '/operationManagement',
        name: 'operationManagement',
        meta: {
            icon: 'ios-paper',
            showAlways: true
        },
        component: Main,
        children: [{
                path: 'orderList',
                name: 'orderList',
                meta: {
                    title: '学生会员订单管理'
                },
                component: () =>
                    import ('@/view/operationManagement/orderList.vue')
            },
            {
                path: 'schoolOrder',
                name: 'schoolOrder',
                meta: {
                    title: '校区充值订单管理'
                },
                component: () =>
                    import ('@/view/operationManagement/schoolOrder.vue')
            },
        ]
    },
    {
        path: '/systemManagement',
        name: 'systemManagement',
        meta: {
            icon: 'ios-cog',
            showAlways: true
        },
        component: Main,
        children: [{
                path: 'adminList',
                name: 'adminList',
                meta: {
                    title: '系统账号管理'
                },
                component: () =>
                    import ('@/view/systemManagement/adminList.vue')
            },
            {
                path: 'roleList',
                name: 'roleList',
                meta: {
                    title: '角色管理'
                },
                component: () =>
                    import ('@/view/systemManagement/roleList.vue')
            },

        ]
    },


    {
        path: '/401',
        name: 'error_401',
        meta: {
            hideInMenu: true
        },
        component: () =>
            import ('@/view/error-page/401.vue')
    },

    {
        path: '/500',
        name: 'error_500',
        meta: {
            hideInMenu: true
        },
        component: () =>
            import ('@/view/error-page/500.vue')
    },
    {
        path: '*',
        name: 'error_404',
        meta: {
            hideInMenu: true
        },
        component: () =>
            import ('@/view/error-page/404.vue')
    }
]